export const addLineBreak = (str) => {

  // Split the string on '\n', then map each substring to JSX
  return str.split('\n').map((subStr, index) => {
    // Check if the substring is our placeholder for a double line break
    if(subStr === ""){
      return (
        ""
      );
    }
    
    return (
      <>
        {subStr.split('\n').map((subStr2, index2) => {
          return (
            <>
              {subStr2}
              <br />
            </>
          );
        })}
        <br />
      </>
    )
  });
};
